export enum ProSkillAssureSampleAssessmentType {
    AWS = "AWS",
    CODE = "CODE",
    SQL_MYSQL = "SQL_MYSQL",
    VS_CODE = "VS_CODE",
    PROMPT = "PROMPT",
    AGENT_PROMPT="AGENT_PROMPT",
    SHORT_QA = "SHORT_QA",
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    MULTI_FILE_CODE_FRONTEND = "MULTI_FILE_CODE_FRONTEND",
    MULTI_FILE_CODE_BACKEND = "MULTI_FILE_CODE_BACKEND",
    MULTI_FILE_CODE = "MULTI_FILE_CODE",
    DESCRIPTIVE_QA = "DESCRIPTIVE_QA",
    CODE_WITHOUT_RUN ="CODE_WITHOUT_RUN",
    INSTRUCTION = "INSTRUCTION",
    INSTRUCTION_SHORT_QA = "INSTRUCTION_SHORT_QA",
    INSTRUCTION_MULTIPLE_CHOICE = "INSTRUCTION_MULTIPLE_CHOICE",
    JUPYTER_NOTEBOOK = "JUPYTER_NOTEBOOK",
    BASIC_PROCTORING = "BASIC_PROCTORING",
    ADVANCED_PROCTORING = "ADVANCED_PROCTORING",
    CODING_AGENT = "CODING_AGENT"
}
